import { SignalrService } from './../../services/signalr/signalr.service';
import { FileManagementService } from '@services/fileManagement/fileManagement.service';
import { Component, EventEmitter, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, RouterLink } from '@angular/router';
import { UserService } from '@services/user/user.service';
import { SessionService } from '@services/session/session.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MenuItem } from 'primeng/api';
import { ModuleAuth } from '@common_libraries/lib/ModuleAuth';
import { TRASecurityModule } from '@common_libraries/lib/Enums';
import { ClickType, NavigationHelper } from '@common_libraries/helpers/NavigationHelper';
import { environment } from '@environments/environment';
import { NotificationCenterService } from '@services/notificationCenter/notification-center.service';
import { GrowlService, GrowlSeverity } from '@common_libraries/controls/Growl/services/growl.service';
import { Subscription } from 'rxjs';
import { PollGuard } from '@library/helpers/PollGuard';
import { NotificationCenterHelperService } from '@services/notificationCenter/helpers/notification-center-helper.service';
import { OktaAuthService } from '@common_libraries/Services/login/oktaAuth.service';
import { NotificationCenterComponent } from '../notification-center/notification-center.component';
import { CompanyPickerComponent } from '../company-picker/company-picker.component';
import { NgClass } from '@angular/common';
import { ClickOutsideDirective } from '@pageControls/click-outside/click-outside';

@Component({
    selector: 'app-master-title',
    templateUrl: './master-title.component.html',
    styleUrls: ['./master-title.component.scss'],
    providers: [],
    standalone: true,
    imports: [NgClass, RouterLink, CompanyPickerComponent, NotificationCenterComponent, ClickOutsideDirective]
})
export class MasterTitleComponent implements OnInit, OnDestroy {
  public userEmail: string;
  public navUrl: string;
  public showNav = false;
  public adminModule = TRASecurityModule.Admin;
  public accountSettingsModule = TRASecurityModule.AccountSettings;
  public companyAdminModule = TRASecurityModule.Admin_CompanyAdmin;
  public accountManagerModule = TRASecurityModule.Admin_AccountManager;
  public isAuthSysAdmin: boolean;
  public isAuthAccountSettings: boolean;
  sendNotify: number = 0;
  private windowNavigator: any = window.navigator;

  sectionMenuVisible = false;
  accountMenuVisible = false;

  constructor(private route: ActivatedRoute,
    public router: Router,
    private userService: UserService,
    private localSt: LocalStorageService,
    private sessionService: SessionService,
    private moduleAuth: ModuleAuth,

    private sessionSvc: SessionService,
    private growlService: GrowlService,
    private fileManagementService: FileManagementService,
    private okta: OktaAuthService,
    private SignalRService: SignalrService
  ) {

    // do initial nav setup
    this.setupShowNav();

    // on every route change check if we should update this
    router.events.subscribe((val) => {
      this.setupShowNav();
    });

    this.isAuthSysAdmin = false;
    this.isAuthAccountSettings = false;
  }

  ngOnInit() {
    this.setupIsAuth();
    this.moduleAuth.AuthChange.subscribe(() => { this.setupIsAuth() });
    this.determineNavUrl();
    if (this.sessionService.GetIsLoggedIn()) {
      this.userService.getCurrentUser().subscribe((res: any) => {
        this.userEmail = res.json.data.email;
      });
      if (this.SignalRService.getHubConnection() === null || this.SignalRService.getHubConnection() === undefined) { 
        this.SignalRService.startConnection();
      }
    }

    this.sessionService.LoginChange.subscribe((loggedIn: boolean) => {
      if (loggedIn) {
        this.userService.getCurrentUser().subscribe((res: any) => {
          this.userEmail = res.json.data.email;
          this.setupIsAuth();
        });
        if (this.SignalRService.getHubConnection() === null || this.SignalRService.getHubConnection() === undefined) { 
          this.SignalRService.startConnection();
        }
      } else {
        this.userEmail = null;
      }
    });

    this.setupBrowserLock();

  }

  // This should prevent the browser from garbage collecting connections on this tab
  setupBrowserLock() {
    var lockResolver;
    if (this.windowNavigator && this.windowNavigator.locks && this.windowNavigator.locks.request) {
        const promise = new Promise((res) => {
            lockResolver = res;
        });
    
        this.windowNavigator.locks.request('unique_lock_name', { mode: "shared" }, () => {
            return promise;
        });
    }
  }

  setupShowNav() {
    // don't show the top nav if on login or the user is not logged in
    if (window.location.href.includes('/login') || window.location.href.includes('/callback') || this.sessionService.GetIsLoggedIn() === false || window.location.href === window.location.origin + '/404') {
      this.showNav = false;
    } else {
      this.showNav = true;

      // everytime the route changes, lets check for new notifications
      this.sendNotify = new Date().getTime();
    }

    this.determineNavUrl();
  }

  setupIsAuth() {
    this.isAuthSysAdmin = this.isUserAuthed([this.adminModule, this.companyAdminModule, this.accountManagerModule]);
    this.isAuthAccountSettings = this.isUserAuthed([this.accountSettingsModule]);
  }

  navigate(event: any) {
    const navHelper = new NavigationHelper(this.router);
    navHelper.Navigate([ClickType.LEFT, ClickType.MIDDLE, ClickType.CTRL], this.navUrl, event);
    return false;
  }

  setNavUrl(newNavUrl: string, event: any) {
    this.navUrl = newNavUrl;
    this.navigate(event);
    return false;
  }

  tabNavigate(tab: string, event: any) {
    const navHelp = new NavigationHelper(this.router);
    navHelp.Navigate([ClickType.CTRL, ClickType.MIDDLE, ClickType.LEFT], tab, event);
    return false;
  }

  // Menu Dropdown Toggling
  toggleSectionDropdown() {
    this.sectionMenuVisible = !this.sectionMenuVisible;
  }
  
  toggleAccountDropdown() {
    this.accountMenuVisible = !this.accountMenuVisible;
  }
  
  clickOutsideSection() {
    this.sectionMenuVisible = false;
  }

  clickOutsideAccount() {
    this.accountMenuVisible = false;
  }

  logout() {
    this.sessionService.SetIsLoggedIn(false);
    this.okta.logout();
  }

  determineNavUrl() {
    const basePath = window.location.pathname.split('\/')[1];
    if (basePath.indexOf('analysis') > -1) {
      this.navUrl = 'analysis';
    } else if (basePath.indexOf('data') > -1) {
      this.navUrl = 'data';
    } else if (basePath.indexOf('folders') > -1) {
      this.navUrl = 'folders';
    } else {
      this.navUrl = 'portfolios';
    }
  }

  isUserAuthed(module: TRASecurityModule[]) {
    const isAuthed = module.some(x => {
      // console.log('checking auth for module - ' + x + ':' +  this.moduleAuth.IsUserAuthed(x));
      return this.moduleAuth.IsUserAuthed(x);
    });

    return isAuthed;
  }

  getHelpLink(event: any) {
    this.userService.GetHelpLink().subscribe((res: any) => {
      const navHelp = new NavigationHelper(this.router);
      console.log(navHelp);
      console.log(res.url);
      navHelp.Navigate([ClickType.CTRL, ClickType.MIDDLE, ClickType.LEFT], res.url, event, true);
    });
  }




  ngOnDestroy() {
  }



}
